import {
    api_getProfileURLUploadImage,
    api_getUserProfile,
    api_patchUserProfile,
    api_setUserProfile,
    api_getAddress,
    api_setAddress,
    api_patchAddress
} from "./userProfile.api";
import {
    setUserProfile,
    setProfileImageLink,
    setAddress,
    setUserName
} from "./userProfile.reducers";


export const getUserProfile = params => dispatch => (
    api_getUserProfile(params).then(res => {
        dispatch(setUserProfile(
            (Array.isArray(res) && res.length)
                ? res[0]
                : {}
        ));
        return res;
    })
);

export const createUserProfile = params => dispatch => (
    api_setUserProfile(params).then(res => {
        dispatch(setUserProfile(res));
    })
);

export const patchUserProfile = params => dispatch => (
    api_patchUserProfile(params).then(res => {
        dispatch(setUserProfile(res));
    })
);

export const getProfileURLUploadImage = params => dispatch => (
    api_getProfileURLUploadImage(params).then(res => {
        dispatch(setProfileImageLink(res.downloadUrl));
        return res;
    })
);

export const getAddress = params => dispatch => (
    api_getAddress(params).then(res => {
        const address = res.find((address => address.defaultAddress === true));
        if(address) {
            dispatch(setAddress(
                (Array.isArray(res) && res.length)
                    ? address
                    : {}
            ));
        }
        return address;
    })
);
export const patchAddress = (id, body) => dispatch => (
    api_patchAddress(id, body).then(res => {
        dispatch(setAddress(res));
        return res;
    })
);

export const addAddress = params => dispatch => (
    api_setAddress(params).then(res => {
        dispatch(setAddress(res));
        return res;
    })
);

export const setUserFullName = params => dispatch => (
    dispatch(setUserName(params))
);
